<div class="fc-dropdown-toggle-wrapper">
    <div
        class="fc-dropdown-toggle-input fc-dropdown-toggle-input-{{ typeName }}"
        aria-haspopup="true"
        [ngClass]="{ 'fc-dropdown-toggle-disabled': disabled }"
    >
        <div class="fc-dropdown-toggle-content" data-e2e-hook="dropdown-toggle-content">
            <ng-content></ng-content>
        </div>
        <span class="fc-dropdown-toggle-icon" data-e2e-hook="dropdown-options-icon" aria-expanded="false">
            <i class="fa fa-caret-{{ dropdownDirection }}"></i>
        </span>
    </div>
</div>
